// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/actions.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { Struct } from "../../../../google/protobuf/struct";
import { TaskType } from "./task";
import { TaskActionState } from "./task";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { TaskView } from "./task";
import { TaskExpandMask } from "./task";
import { TaskSearchRequest } from "./search";
import { TaskActionType } from "./task";
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressRequest
 */
export interface TaskActionsServiceGetBulkActionProgressRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 4;
     */
    entitlementId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceListBulkActionInProgressRequest
 */
export interface TaskActionsServiceListBulkActionInProgressRequest {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceListBulkActionInProgressResponse
 */
export interface TaskActionsServiceListBulkActionInProgressResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.BulkAction list = 1;
     */
    list: BulkAction[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressByIdRequest
 */
export interface TaskActionsServiceGetBulkActionProgressByIdRequest {
    /**
     * @generated from protobuf field: repeated string bulk_action_ids = 2;
     */
    bulkActionIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressByIdResponse
 */
export interface TaskActionsServiceGetBulkActionProgressByIdResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.BulkActionProgress list = 2;
     */
    list: BulkActionProgress[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetSingleBulkActionProgressByIdRequest
 */
export interface TaskActionsServiceGetSingleBulkActionProgressByIdRequest {
    /**
     * @generated from protobuf field: string bulk_action_id = 1;
     */
    bulkActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetSingleBulkActionProgressByIdResponse
 */
export interface TaskActionsServiceGetSingleBulkActionProgressByIdResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.BulkActionProgress bulk_action_progress = 1;
     */
    bulkActionProgress?: BulkActionProgress;
}
/**
 * This object references a bulk action by ID.
 *
 * @generated from protobuf message c1.api.task.v1.TaskBulkActionRef
 */
export interface TaskBulkActionRef {
    /**
     * The ID of the referenced bulk action
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * This object references a bulk action item by ID.
 *
 * @generated from protobuf message c1.api.task.v1.BulkActionItemRef
 */
export interface BulkActionItemRef {
    /**
     * The ID of the referenced bulk action item
     *
     * @generated from protobuf field: string ticket_id = 1;
     */
    ticketId: string;
    /**
     * @generated from protobuf field: string bulk_action_id = 2;
     */
    bulkActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.BulkAction
 */
export interface BulkAction {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskActionType action_type = 3;
     */
    actionType: TaskActionType;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest search_request = 4;
     */
    searchRequest?: TaskSearchRequest;
    /**
     * @generated from protobuf field: c1.api.task.v1.BulkActionProgress progress = 5;
     */
    progress?: BulkActionProgress;
}
/**
 * @generated from protobuf message c1.api.task.v1.BulkActionProgress
 */
export interface BulkActionProgress {
    /**
     * @generated from protobuf field: int64 success_actions = 1;
     */
    successActions: number;
    /**
     * @generated from protobuf field: int64 error_actions = 2;
     */
    errorActions: number;
    /**
     * @generated from protobuf field: int64 pending_actions = 3;
     */
    pendingActions: number;
    /**
     * @generated from protobuf field: int64 total_actions = 4;
     */
    totalActions: number;
    /**
     * @generated from protobuf field: string id = 5;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressResponse
 */
export interface TaskActionsServiceGetBulkActionProgressResponse {
    /**
     * @generated from protobuf field: int64 success_actions = 1;
     */
    successActions: number;
    /**
     * @generated from protobuf field: int64 error_actions = 2;
     */
    errorActions: number;
    /**
     * @generated from protobuf field: int64 pending_actions = 3;
     */
    pendingActions: number;
    /**
     * @generated from protobuf field: int64 total_actions = 4;
     */
    totalActions: number;
    /**
     * @generated from protobuf field: string id = 5;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest search_request = 6;
     */
    searchRequest?: TaskSearchRequest;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceBulkRequest
 */
export interface TaskActionsServiceBulkRequest {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskActionType action_type = 1;
     */
    actionType: TaskActionType;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest search_request = 2;
     */
    searchRequest?: TaskSearchRequest;
    /**
     * @generated from protobuf field: string comment = 3;
     */
    comment: string;
    /**
     * @generated from protobuf oneof: action_args
     */
    actionArgs: {
        oneofKind: "reassign";
        /**
         * @generated from protobuf field: c1.api.task.v1.ReassignActionArgs reassign = 4;
         */
        reassign: ReassignActionArgs;
    } | {
        oneofKind: "changePolicy";
        /**
         * @generated from protobuf field: c1.api.task.v1.ChangePolicyActionArgs change_policy = 5;
         */
        changePolicy: ChangePolicyActionArgs;
    } | {
        oneofKind: "certify";
        /**
         * @generated from protobuf field: c1.api.task.v1.CertifyActionArgs certify = 7;
         */
        certify: CertifyActionArgs;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceBulkResponse
 */
export interface TaskActionsServiceBulkResponse {
    /**
     * @generated from protobuf field: string bulk_action_id = 1;
     */
    bulkActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.ReassignActionArgs
 */
export interface ReassignActionArgs {
    /**
     * @generated from protobuf field: repeated string new_user_ids = 1;
     */
    newUserIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.ChangePolicyActionArgs
 */
export interface ChangePolicyActionArgs {
    /**
     * @generated from protobuf field: string new_policy_id = 1;
     */
    newPolicyId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CertifyActionArgs
 */
export interface CertifyActionArgs {
    /**
     * When true, creates ReviewPendingAction objects instead of directly processing tickets.
     * Used for access review bulk certify/deny operations.
     *
     * @generated from protobuf field: bool create_pending_actions = 1;
     */
    createPendingActions: boolean;
}
/**
 * The TaskActionsServiceCommentRequest object lets you create a new comment on a task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceCommentRequest
 */
export interface TaskActionsServiceCommentRequest {
    /**
     * The ID of the task to be commented on
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The comment to be posted to the ticket
     *
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * Expand masks describe which sub_fields of a ticket you want expanded into a full object and included in the expanded array. Use `*` for all fields.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3;
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskActionsServiceCloseRequest object lets you close or cancel a task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceCloseRequest
 */
export interface TaskActionsServiceCloseRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3;
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskActionsServiceCloseResponse returns a task view with paths indicating the location of expanded items in the array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceCloseResponse
 */
export interface TaskActionsServiceCloseResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The ID of the task close action created by this request.
     *
     * @generated from protobuf field: string task_action_id = 3;
     */
    taskActionId: string;
}
/**
 * The TaskActionsServiceDenyRequest object lets you deny a task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceDenyRequest
 */
export interface TaskActionsServiceDenyRequest {
    /**
     * The ID of the task to be denied.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The comment attached to the request.
     *
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * The ID of the currently policy step. This is the step you want to deny.
     *
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string;
    /**
     * Expand masks describe which sub_fields of a ticket you want expanded into a full object and included in the expanded array. Use `*` for all fields.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskActionsServiceApproveRequest object lets you approve a task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceApproveRequest
 */
export interface TaskActionsServiceApproveRequest {
    /**
     * The ID of the task to approve.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The comment attached to the request.
     *
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * The ID of the policy step on the given task to approve.
     *
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceReassignRequest
 */
export interface TaskActionsServiceReassignRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * @generated from protobuf field: repeated string new_step_user_ids = 3;
     */
    newStepUserIds: string[];
    /**
     * @generated from protobuf field: string policy_step_id = 4;
     */
    policyStepId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 5;
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskActionsServiceRestartRequest object lets you restart a task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceRestartRequest
 */
export interface TaskActionsServiceRestartRequest {
    /**
     * The ID of the task to restart.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The comment attached to the request.
     *
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * The ID of the policy step on the given task to restart.
     *
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string; // Exists to satisfy the TaskActionsServiceEscalateToEmergencyAccessRequest pattern but is not used.
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskActionsServiceHardResetRequest object lets you reset a task and recalculate its policy.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceHardResetRequest
 */
export interface TaskActionsServiceHardResetRequest {
    /**
     * The ID of the task to reset.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The comment attached to the request.
     *
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskActionsServiceProcessNowRequest object lets you trigger processing of a task immediately.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceProcessNowRequest
 */
export interface TaskActionsServiceProcessNowRequest {
    /**
     * The ID of the task to process now.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 2;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceEscalateToEmergencyAccessRequest
 */
export interface TaskActionsServiceEscalateToEmergencyAccessRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceMarkProvisionCompleteRequest
 */
export interface TaskActionsServiceMarkProvisionCompleteRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * @deprecated
     * @generated from protobuf field: repeated string app_entitlement_ids = 3 [deprecated = true];
     */
    appEntitlementIds: string[];
    /**
     * @generated from protobuf field: string policy_step_id = 4;
     */
    policyStepId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 5;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceMarkProvisionErroredRequest
 */
export interface TaskActionsServiceMarkProvisionErroredRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAction
 */
export interface TaskAction {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskActionType action_type = 4;
     */
    actionType: TaskActionType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string bulk_action_id = 8;
     */
    bulkActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceActionResponse
 */
export interface TaskServiceActionResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string ticket_action_id = 3;
     */
    ticketActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceRestartResponse
 */
export interface TaskActionsServiceRestartResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string ticket_action_id = 3;
     */
    ticketActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceHardResetResponse
 */
export interface TaskActionsServiceHardResetResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string ticket_action_id = 3;
     */
    ticketActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceProcessNowResponse
 */
export interface TaskActionsServiceProcessNowResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.GetTaskActionStateRequest
 */
export interface GetTaskActionStateRequest {
    /**
     * @generated from protobuf field: repeated string ticket_action_ids = 1;
     */
    ticketActionIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionStateItem
 */
export interface TaskActionStateItem {
    /**
     * @generated from protobuf field: string ticket_action_id = 1;
     */
    ticketActionId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskActionState state = 2;
     */
    state: TaskActionState;
}
/**
 * @generated from protobuf message c1.api.task.v1.GetTaskActionStateResponse
 */
export interface GetTaskActionStateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskActionStateItem items = 1;
     */
    items: TaskActionStateItem[];
}
/**
 * The TaskActionsServiceApproveResponse returns a task view with paths indicating the location of expanded items in the array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceApproveResponse
 */
export interface TaskActionsServiceApproveResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The ID of the ticket (task) approve action created by this request.
     *
     * @generated from protobuf field: string ticket_action_id = 3;
     */
    ticketActionId: string;
}
/**
 * The TaskActionsServiceDenyResponse returns a task view with paths indicating the location of expanded items in the array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceDenyResponse
 */
export interface TaskActionsServiceDenyResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The ID of the ticket (task) deny action created by this request.
     *
     * @generated from protobuf field: string ticket_action_id = 3;
     */
    ticketActionId: string;
}
/**
 * Task actions service comment response returns the task view inluding the expanded array of items that are indicated by the expand mask on the request.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceCommentResponse
 */
export interface TaskActionsServiceCommentResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The TaskActionsServiceReassignResponse returns a task view with paths indicating the location of expanded items in the array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceReassignResponse
 */
export interface TaskActionsServiceReassignResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The ID of the ticket (task) deny action created by this request.
     *
     * @generated from protobuf field: string ticket_action_id = 3;
     */
    ticketActionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetAllowedBulkActionsRequest
 */
export interface TaskActionsServiceGetAllowedBulkActionsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskType task_types = 2;
     */
    taskTypes: TaskType[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceGetAllowedBulkActionsResponse
 */
export interface TaskActionsServiceGetAllowedBulkActionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskActionType task_action_types = 1;
     */
    taskActionTypes: TaskActionType[];
}
/**
 * TaskActionsServiceApproveWithStepUpRequest is used to approve a task with step-up authentication
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceApproveWithStepUpRequest
 */
export interface TaskActionsServiceApproveWithStepUpRequest {
    /**
     * The ID of the task to approve with step-up.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The comment attached to the request.
     *
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * The ID of the policy step on the given task to approve.
     *
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string;
    /**
     * The step-up transaction ID that was verified.
     * If unset, the response will include a redirect URL to
     * complete the step-up authentication.
     *
     * @generated from protobuf field: string step_up_transaction_id = 4;
     */
    stepUpTransactionId: string;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 5;
     */
    expandMask?: TaskExpandMask;
}
/**
 * TaskActionsServiceApproveWithStepUpResponse is the response for approving a task with step-up authentication
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceApproveWithStepUpResponse
 */
export interface TaskActionsServiceApproveWithStepUpResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The ID of the ticket (task) approve action created by this request.
     *
     * @generated from protobuf field: string ticket_action_id = 3;
     */
    ticketActionId: string;
    /**
     * The redirect URL the client must visit to complete the step-up authentication.
     *
     * @generated from protobuf field: string redirect_url = 4;
     */
    redirectUrl: string;
}
/**
 * The TaskActionsServiceSkipStepRequest object lets you skip a policy step in a task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceSkipStepRequest
 */
export interface TaskActionsServiceSkipStepRequest {
    /**
     * The ID of the task containing the step to skip.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The comment attached to the request.
     *
     * @generated from protobuf field: string comment = 2;
     */
    comment: string;
    /**
     * The ID of the policy step to skip.
     *
     * @generated from protobuf field: string policy_step_id = 3;
     */
    policyStepId: string;
    /**
     * Expand masks describe which sub_fields of a ticket you want expanded into a full object and included in the expanded array. Use `*` for all fields.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceUpdateRequestDataRequest
 */
export interface TaskActionsServiceUpdateRequestDataRequest {
    /**
     * The ID of the task containing the request data to update.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The updated request data to update the ticket with.
     *
     * @generated from protobuf field: google.protobuf.Struct data = 2;
     */
    data?: Struct;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskActionsServiceUpdateGrantDurationRequest
 */
export interface TaskActionsServiceUpdateGrantDurationRequest {
    /**
     * The ID of the task to update the grant duration for.
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * The new grant duration.
     *
     * @generated from protobuf field: google.protobuf.Duration duration = 2;
     */
    duration?: Duration;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3;
     */
    expandMask?: TaskExpandMask;
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetBulkActionProgressRequest$Type extends MessageType<TaskActionsServiceGetBulkActionProgressRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetBulkActionProgressRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressRequest
 */
export const TaskActionsServiceGetBulkActionProgressRequest = new TaskActionsServiceGetBulkActionProgressRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceListBulkActionInProgressRequest$Type extends MessageType<TaskActionsServiceListBulkActionInProgressRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceListBulkActionInProgressRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceListBulkActionInProgressRequest
 */
export const TaskActionsServiceListBulkActionInProgressRequest = new TaskActionsServiceListBulkActionInProgressRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceListBulkActionInProgressResponse$Type extends MessageType<TaskActionsServiceListBulkActionInProgressResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceListBulkActionInProgressResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BulkAction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceListBulkActionInProgressResponse
 */
export const TaskActionsServiceListBulkActionInProgressResponse = new TaskActionsServiceListBulkActionInProgressResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetBulkActionProgressByIdRequest$Type extends MessageType<TaskActionsServiceGetBulkActionProgressByIdRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetBulkActionProgressByIdRequest", [
            { no: 2, name: "bulk_action_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressByIdRequest
 */
export const TaskActionsServiceGetBulkActionProgressByIdRequest = new TaskActionsServiceGetBulkActionProgressByIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetBulkActionProgressByIdResponse$Type extends MessageType<TaskActionsServiceGetBulkActionProgressByIdResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetBulkActionProgressByIdResponse", [
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BulkActionProgress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressByIdResponse
 */
export const TaskActionsServiceGetBulkActionProgressByIdResponse = new TaskActionsServiceGetBulkActionProgressByIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetSingleBulkActionProgressByIdRequest$Type extends MessageType<TaskActionsServiceGetSingleBulkActionProgressByIdRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetSingleBulkActionProgressByIdRequest", [
            { no: 1, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetSingleBulkActionProgressByIdRequest
 */
export const TaskActionsServiceGetSingleBulkActionProgressByIdRequest = new TaskActionsServiceGetSingleBulkActionProgressByIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetSingleBulkActionProgressByIdResponse$Type extends MessageType<TaskActionsServiceGetSingleBulkActionProgressByIdResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetSingleBulkActionProgressByIdResponse", [
            { no: 1, name: "bulk_action_progress", kind: "message", T: () => BulkActionProgress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetSingleBulkActionProgressByIdResponse
 */
export const TaskActionsServiceGetSingleBulkActionProgressByIdResponse = new TaskActionsServiceGetSingleBulkActionProgressByIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskBulkActionRef$Type extends MessageType<TaskBulkActionRef> {
    constructor() {
        super("c1.api.task.v1.TaskBulkActionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskBulkActionRef
 */
export const TaskBulkActionRef = new TaskBulkActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionItemRef$Type extends MessageType<BulkActionItemRef> {
    constructor() {
        super("c1.api.task.v1.BulkActionItemRef", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.BulkActionItemRef
 */
export const BulkActionItemRef = new BulkActionItemRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkAction$Type extends MessageType<BulkAction> {
    constructor() {
        super("c1.api.task.v1.BulkAction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "action_type", kind: "enum", T: () => ["c1.api.task.v1.TaskActionType", TaskActionType, "TASK_ACTION_TYPE_"] },
            { no: 4, name: "search_request", kind: "message", T: () => TaskSearchRequest },
            { no: 5, name: "progress", kind: "message", T: () => BulkActionProgress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.BulkAction
 */
export const BulkAction = new BulkAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkActionProgress$Type extends MessageType<BulkActionProgress> {
    constructor() {
        super("c1.api.task.v1.BulkActionProgress", [
            { no: 1, name: "success_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "error_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pending_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "total_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.BulkActionProgress
 */
export const BulkActionProgress = new BulkActionProgress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetBulkActionProgressResponse$Type extends MessageType<TaskActionsServiceGetBulkActionProgressResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetBulkActionProgressResponse", [
            { no: 1, name: "success_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "error_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pending_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "total_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "search_request", kind: "message", T: () => TaskSearchRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetBulkActionProgressResponse
 */
export const TaskActionsServiceGetBulkActionProgressResponse = new TaskActionsServiceGetBulkActionProgressResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceBulkRequest$Type extends MessageType<TaskActionsServiceBulkRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceBulkRequest", [
            { no: 1, name: "action_type", kind: "enum", T: () => ["c1.api.task.v1.TaskActionType", TaskActionType, "TASK_ACTION_TYPE_"] },
            { no: 2, name: "search_request", kind: "message", T: () => TaskSearchRequest },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reassign", kind: "message", oneof: "actionArgs", T: () => ReassignActionArgs },
            { no: 5, name: "change_policy", kind: "message", oneof: "actionArgs", T: () => ChangePolicyActionArgs },
            { no: 7, name: "certify", kind: "message", oneof: "actionArgs", T: () => CertifyActionArgs }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceBulkRequest
 */
export const TaskActionsServiceBulkRequest = new TaskActionsServiceBulkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceBulkResponse$Type extends MessageType<TaskActionsServiceBulkResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceBulkResponse", [
            { no: 1, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceBulkResponse
 */
export const TaskActionsServiceBulkResponse = new TaskActionsServiceBulkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReassignActionArgs$Type extends MessageType<ReassignActionArgs> {
    constructor() {
        super("c1.api.task.v1.ReassignActionArgs", [
            { no: 1, name: "new_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ReassignActionArgs
 */
export const ReassignActionArgs = new ReassignActionArgs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangePolicyActionArgs$Type extends MessageType<ChangePolicyActionArgs> {
    constructor() {
        super("c1.api.task.v1.ChangePolicyActionArgs", [
            { no: 1, name: "new_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ChangePolicyActionArgs
 */
export const ChangePolicyActionArgs = new ChangePolicyActionArgs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CertifyActionArgs$Type extends MessageType<CertifyActionArgs> {
    constructor() {
        super("c1.api.task.v1.CertifyActionArgs", [
            { no: 1, name: "create_pending_actions", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CertifyActionArgs
 */
export const CertifyActionArgs = new CertifyActionArgs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceCommentRequest$Type extends MessageType<TaskActionsServiceCommentRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceCommentRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceCommentRequest
 */
export const TaskActionsServiceCommentRequest = new TaskActionsServiceCommentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceCloseRequest$Type extends MessageType<TaskActionsServiceCloseRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceCloseRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceCloseRequest
 */
export const TaskActionsServiceCloseRequest = new TaskActionsServiceCloseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceCloseResponse$Type extends MessageType<TaskActionsServiceCloseResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceCloseResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "task_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceCloseResponse
 */
export const TaskActionsServiceCloseResponse = new TaskActionsServiceCloseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceDenyRequest$Type extends MessageType<TaskActionsServiceDenyRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceDenyRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceDenyRequest
 */
export const TaskActionsServiceDenyRequest = new TaskActionsServiceDenyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceApproveRequest$Type extends MessageType<TaskActionsServiceApproveRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceApproveRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceApproveRequest
 */
export const TaskActionsServiceApproveRequest = new TaskActionsServiceApproveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceReassignRequest$Type extends MessageType<TaskActionsServiceReassignRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceReassignRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "new_step_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceReassignRequest
 */
export const TaskActionsServiceReassignRequest = new TaskActionsServiceReassignRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceRestartRequest$Type extends MessageType<TaskActionsServiceRestartRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceRestartRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceRestartRequest
 */
export const TaskActionsServiceRestartRequest = new TaskActionsServiceRestartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceHardResetRequest$Type extends MessageType<TaskActionsServiceHardResetRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceHardResetRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceHardResetRequest
 */
export const TaskActionsServiceHardResetRequest = new TaskActionsServiceHardResetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceProcessNowRequest$Type extends MessageType<TaskActionsServiceProcessNowRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceProcessNowRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceProcessNowRequest
 */
export const TaskActionsServiceProcessNowRequest = new TaskActionsServiceProcessNowRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceEscalateToEmergencyAccessRequest$Type extends MessageType<TaskActionsServiceEscalateToEmergencyAccessRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceEscalateToEmergencyAccessRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceEscalateToEmergencyAccessRequest
 */
export const TaskActionsServiceEscalateToEmergencyAccessRequest = new TaskActionsServiceEscalateToEmergencyAccessRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceMarkProvisionCompleteRequest$Type extends MessageType<TaskActionsServiceMarkProvisionCompleteRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceMarkProvisionCompleteRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceMarkProvisionCompleteRequest
 */
export const TaskActionsServiceMarkProvisionCompleteRequest = new TaskActionsServiceMarkProvisionCompleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceMarkProvisionErroredRequest$Type extends MessageType<TaskActionsServiceMarkProvisionErroredRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceMarkProvisionErroredRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceMarkProvisionErroredRequest
 */
export const TaskActionsServiceMarkProvisionErroredRequest = new TaskActionsServiceMarkProvisionErroredRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAction$Type extends MessageType<TaskAction> {
    constructor() {
        super("c1.api.task.v1.TaskAction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "action_type", kind: "enum", T: () => ["c1.api.task.v1.TaskActionType", TaskActionType, "TASK_ACTION_TYPE_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "bulk_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAction
 */
export const TaskAction = new TaskAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceActionResponse$Type extends MessageType<TaskServiceActionResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceActionResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceActionResponse
 */
export const TaskServiceActionResponse = new TaskServiceActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceRestartResponse$Type extends MessageType<TaskActionsServiceRestartResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceRestartResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceRestartResponse
 */
export const TaskActionsServiceRestartResponse = new TaskActionsServiceRestartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceHardResetResponse$Type extends MessageType<TaskActionsServiceHardResetResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceHardResetResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceHardResetResponse
 */
export const TaskActionsServiceHardResetResponse = new TaskActionsServiceHardResetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceProcessNowResponse$Type extends MessageType<TaskActionsServiceProcessNowResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceProcessNowResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceProcessNowResponse
 */
export const TaskActionsServiceProcessNowResponse = new TaskActionsServiceProcessNowResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaskActionStateRequest$Type extends MessageType<GetTaskActionStateRequest> {
    constructor() {
        super("c1.api.task.v1.GetTaskActionStateRequest", [
            { no: 1, name: "ticket_action_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GetTaskActionStateRequest
 */
export const GetTaskActionStateRequest = new GetTaskActionStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionStateItem$Type extends MessageType<TaskActionStateItem> {
    constructor() {
        super("c1.api.task.v1.TaskActionStateItem", [
            { no: 1, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.task.v1.TaskActionState", TaskActionState, "TASK_ACTION_STATE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionStateItem
 */
export const TaskActionStateItem = new TaskActionStateItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTaskActionStateResponse$Type extends MessageType<GetTaskActionStateResponse> {
    constructor() {
        super("c1.api.task.v1.GetTaskActionStateResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskActionStateItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GetTaskActionStateResponse
 */
export const GetTaskActionStateResponse = new GetTaskActionStateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceApproveResponse$Type extends MessageType<TaskActionsServiceApproveResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceApproveResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceApproveResponse
 */
export const TaskActionsServiceApproveResponse = new TaskActionsServiceApproveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceDenyResponse$Type extends MessageType<TaskActionsServiceDenyResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceDenyResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceDenyResponse
 */
export const TaskActionsServiceDenyResponse = new TaskActionsServiceDenyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceCommentResponse$Type extends MessageType<TaskActionsServiceCommentResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceCommentResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceCommentResponse
 */
export const TaskActionsServiceCommentResponse = new TaskActionsServiceCommentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceReassignResponse$Type extends MessageType<TaskActionsServiceReassignResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceReassignResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceReassignResponse
 */
export const TaskActionsServiceReassignResponse = new TaskActionsServiceReassignResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetAllowedBulkActionsRequest$Type extends MessageType<TaskActionsServiceGetAllowedBulkActionsRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetAllowedBulkActionsRequest", [
            { no: 2, name: "task_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetAllowedBulkActionsRequest
 */
export const TaskActionsServiceGetAllowedBulkActionsRequest = new TaskActionsServiceGetAllowedBulkActionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceGetAllowedBulkActionsResponse$Type extends MessageType<TaskActionsServiceGetAllowedBulkActionsResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceGetAllowedBulkActionsResponse", [
            { no: 1, name: "task_action_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.TaskActionType", TaskActionType, "TASK_ACTION_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceGetAllowedBulkActionsResponse
 */
export const TaskActionsServiceGetAllowedBulkActionsResponse = new TaskActionsServiceGetAllowedBulkActionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceApproveWithStepUpRequest$Type extends MessageType<TaskActionsServiceApproveWithStepUpRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceApproveWithStepUpRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 4, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceApproveWithStepUpRequest
 */
export const TaskActionsServiceApproveWithStepUpRequest = new TaskActionsServiceApproveWithStepUpRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceApproveWithStepUpResponse$Type extends MessageType<TaskActionsServiceApproveWithStepUpResponse> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceApproveWithStepUpResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "ticket_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "redirect_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceApproveWithStepUpResponse
 */
export const TaskActionsServiceApproveWithStepUpResponse = new TaskActionsServiceApproveWithStepUpResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceSkipStepRequest$Type extends MessageType<TaskActionsServiceSkipStepRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceSkipStepRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceSkipStepRequest
 */
export const TaskActionsServiceSkipStepRequest = new TaskActionsServiceSkipStepRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceUpdateRequestDataRequest$Type extends MessageType<TaskActionsServiceUpdateRequestDataRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceUpdateRequestDataRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "data", kind: "message", T: () => Struct },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceUpdateRequestDataRequest
 */
export const TaskActionsServiceUpdateRequestDataRequest = new TaskActionsServiceUpdateRequestDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskActionsServiceUpdateGrantDurationRequest$Type extends MessageType<TaskActionsServiceUpdateGrantDurationRequest> {
    constructor() {
        super("c1.api.task.v1.TaskActionsServiceUpdateGrantDurationRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { required: true } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskActionsServiceUpdateGrantDurationRequest
 */
export const TaskActionsServiceUpdateGrantDurationRequest = new TaskActionsServiceUpdateGrantDurationRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskActionsService
 */
export const TaskActionsService = new ServiceType("c1.api.task.v1.TaskActionsService", [
    { name: "Approve", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/approve", group: "Task" }] } }, I: TaskActionsServiceApproveRequest, O: TaskActionsServiceApproveResponse },
    { name: "ApproveWithStepUp", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/approve-with-step-up", group: "Task" }] } }, I: TaskActionsServiceApproveWithStepUpRequest, O: TaskActionsServiceApproveWithStepUpResponse },
    { name: "Deny", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/deny", group: "Task" }] } }, I: TaskActionsServiceDenyRequest, O: TaskActionsServiceDenyResponse },
    { name: "Comment", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/comment", group: "Task" }] } }, I: TaskActionsServiceCommentRequest, O: TaskActionsServiceCommentResponse },
    { name: "Close", localName: "close$", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/close", group: "Task" }] } }, I: TaskActionsServiceCloseRequest, O: TaskActionsServiceCloseResponse },
    { name: "Reassign", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/reassign", group: "Task" }] } }, I: TaskActionsServiceReassignRequest, O: TaskActionsServiceReassignResponse },
    { name: "Restart", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/restart", group: "Task" }] } }, I: TaskActionsServiceRestartRequest, O: TaskActionsServiceRestartResponse },
    { name: "HardReset", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/reset", group: "Task" }] } }, I: TaskActionsServiceHardResetRequest, O: TaskActionsServiceHardResetResponse },
    { name: "ProcessNow", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/process", group: "Task" }] } }, I: TaskActionsServiceProcessNowRequest, O: TaskActionsServiceProcessNowResponse },
    { name: "EscalateToEmergencyAccess", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/escalate", group: "Task" }] } }, I: TaskActionsServiceEscalateToEmergencyAccessRequest, O: TaskServiceActionResponse },
    { name: "MarkProvisionComplete", options: { "authz.method": { role: "EDITOR" } }, I: TaskActionsServiceMarkProvisionCompleteRequest, O: TaskServiceActionResponse },
    { name: "MarkProvisionErrored", options: { "authz.method": { role: "EDITOR" } }, I: TaskActionsServiceMarkProvisionErroredRequest, O: TaskServiceActionResponse },
    { name: "SkipStep", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/skip-step", group: "Task" }] } }, I: TaskActionsServiceSkipStepRequest, O: TaskServiceActionResponse },
    { name: "UpdateRequestData", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/update-request-data", group: "Task" }] } }, I: TaskActionsServiceUpdateRequestDataRequest, O: TaskServiceActionResponse },
    { name: "UpdateGrantDuration", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/tasks/{task_id}/action/update-grant-duration", group: "Task" }] } }, I: TaskActionsServiceUpdateGrantDurationRequest, O: TaskServiceActionResponse },
    { name: "BulkRequest", options: { "authz.method": { role: "EDITOR" } }, I: TaskActionsServiceBulkRequest, O: TaskActionsServiceBulkResponse },
    { name: "GetBulkActionProgress", options: { "authz.method": { role: "VIEWER" } }, I: TaskActionsServiceGetBulkActionProgressRequest, O: TaskActionsServiceGetBulkActionProgressResponse },
    { name: "ListBulkActionInProgress", options: { "authz.method": { role: "VIEWER" } }, I: TaskActionsServiceListBulkActionInProgressRequest, O: TaskActionsServiceListBulkActionInProgressResponse },
    { name: "GetBulkActionProgressById", options: { "authz.method": { role: "VIEWER" } }, I: TaskActionsServiceGetBulkActionProgressByIdRequest, O: TaskActionsServiceGetBulkActionProgressByIdResponse },
    { name: "GetSingleBulkActionProgressById", options: { "authz.method": { role: "VIEWER" } }, I: TaskActionsServiceGetSingleBulkActionProgressByIdRequest, O: TaskActionsServiceGetSingleBulkActionProgressByIdResponse },
    { name: "GetTaskActionState", options: { "authz.method": { role: "VIEWER" } }, I: GetTaskActionStateRequest, O: GetTaskActionStateResponse },
    { name: "GetAllowedBulkActions", options: { "authz.method": { role: "VIEWER" } }, I: TaskActionsServiceGetAllowedBulkActionsRequest, O: TaskActionsServiceGetAllowedBulkActionsResponse }
]);
